export interface ITreeTranslations {
  readonly RI_TREE_LBL_ADD_NODE: string;
  readonly RI_TREE_LBL_EDIT_NODE: string;
  readonly RI_TREE_LBL_REMOVE_NODE: string;
  readonly RI_TREE_LBL_DROP_ZONE: string;
}
